module.exports = require("@mui/icons-material/FilterAlt");